import { showSuccess, showError } from "@/lib/toastHelpers";
import { useQuery } from "@tanstack/react-query";
import { useApiMutation } from "@/hooks/useApiMutation";
import { apiRequest, queryClient } from "@/lib/queryClient";

type CategoryType = 'ingredients' | 'materials' | 'equipment' | 'recipes';

interface Category {
  _id: string;
  id: string;
  name: string;
  notes?: string;
}

export function useStarterCategories(type: CategoryType) {
  const endpoint = `/api/starter-pack/categories/${type}`;

  const { data: categories, isLoading } = useQuery<Category[]>({
    queryKey: [endpoint],
  });

  const createMutation = useApiMutation({
    endpoint: endpoint,
    method: "POST",
    invalidate: [[endpoint]],
    successMessage: `${type.slice(0, -1)} category created`,
    errorMessage: "Failed to create category",
  });

  const updateMutation = useApiMutation({
    endpoint: (vars: { id: string }) => `${endpoint}/${vars.id}`,
    method: "PATCH",
    invalidate: [[endpoint]],
    successMessage: `${type.slice(0, -1)} category updated`,
    errorMessage: "Failed to update category",
  });

  const deleteMutation = useApiMutation({
    endpoint: (vars: { id: string }) => `${endpoint}/${vars.id}`,
    method: "DELETE",
    invalidate: [[endpoint]],
    successMessage: `${type.slice(0, -1)} category deleted`,
    errorMessage: "Failed to delete category",
  });

  return {
    categories,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
}
